import React from 'react';
import { theme } from '../../design/theme';

interface MetricCardProps {
  label: string;
  value: string | number;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  status?: 'healthy' | 'warning' | 'critical' | 'info';
  sparkline?: React.ReactNode;
}

export const MetricCard: React.FC<MetricCardProps> = ({ 
  label, 
  value, 
  trend, 
  status,
  sparkline 
}) => {
  const statusColor = status ? theme.colors[status].main : 'transparent';

  return (
    <div style={{
      ...theme.card,
      padding: theme.spacing.lg,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing.sm,
      minWidth: '240px',
      position: 'relative',
      overflow: 'hidden',
      transition: 'transform 0.2s, box-shadow 0.2s',
      cursor: 'default',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = theme.shadows.md;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = theme.shadows.sm;
    }}>
      {status && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '4px',
          backgroundColor: statusColor,
        }} />
      )}

        <div style={{
          ...theme.typography.caption,
          color: 'var(--text-secondary)',
          fontWeight: '600',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          backgroundColor: 'var(--bg-muted)',
          padding: '2px 8px',
          borderRadius: '4px',
          width: 'fit-content',
          marginBottom: theme.spacing.xs
        }}>
          {label}
        </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between'
      }}>
        <div style={{
          ...theme.typography.h2,
          fontSize: '28px',
          fontWeight: '700',
          color: 'var(--text-primary)',
          margin: 0
        }}>
          {value}
        </div>
        
        {trend && (
          <div style={{
            ...theme.typography.caption,
            padding: '4px 8px',
            borderRadius: '12px',
            backgroundColor: trend.isPositive ? theme.colors.healthy.light : theme.colors.critical.light,
            color: trend.isPositive ? theme.colors.healthy.dark : theme.colors.critical.dark,
            fontWeight: '700',
            display: 'flex',
            alignItems: 'center',
            gap: '2px'
          }}>
            <span style={{ fontSize: '10px' }}>{trend.isPositive ? '▲' : '▼'}</span>
            {Math.abs(trend.value)}%
          </div>
        )}
      </div>

      {sparkline && (
        <div style={{ 
          marginTop: theme.spacing.md,
          height: '40px',
          width: '100%'
        }}>
          {sparkline}
        </div>
      )}
    </div>
  );
};
